import { useEffect, useState } from 'react'
import { api, urls } from '../../../services/api'
import { IModal } from '../../../types/modal'
import { useApp } from '../../../context/App'
import { X } from 'lucide-react'

export function Popup() {
	const { configApiURL } = useApp()
	const [modalItem, setModal] = useState<IModal>()
	const [isVisible, setIsVisible] = useState(true)

	useEffect(() => {
		(async () => {
			try {
				const responseModal = await api.get<IModal>(urls.Modal)
				setModal(responseModal.data)
			} catch (error) {
				 // console.error('Popup fetch error:', error)
			}
		})()
	}, [])

	if (!isVisible) return null

	const apiUrl = `${configApiURL}public/`;

	return (
		<div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
			{/* Overlay */}
			<div
				className="absolute inset-0 bg-black/70 dark:bg-black/85 backdrop-blur-sm"
				onClick={() => setIsVisible(false)}
				aria-hidden="true"
			/>

			{/* Close button */}
			<button
				className="absolute top-4 right-4 lg:top-6 lg:right-6 z-[1001] w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center bg-white/10 hover:bg-white/25 text-white rounded-full border-none cursor-pointer transition-colors"
				onClick={() => setIsVisible(false)}
				aria-label="Fechar popup"
			>
				<X size={22} />
			</button>

			{/* Content */}
			{!!modalItem?.content && (
				<div
					className={`relative z-[1000] w-full max-w-4xl max-h-[85vh] rounded-2xl overflow-auto shadow-2xl dark-prose ${modalItem?.transparence ? 'bg-transparent' : 'bg-white dark:bg-surface-dark-alt'}`}
					dangerouslySetInnerHTML={{
						__html: modalItem.content
							.replaceAll('src="/public/', `src="${apiUrl}`)
							.toString()
					}}
				/>
			)}
		</div>
	)
}